import { ASSESSMENT_REPORT_V2_QUESTIONS, CONSULTATION_REPORT_V2_QUESTIONS, INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS } from "config/constants";
import { getQuestionById, isHTMLContentEmpty } from "helpers/common";
import { numberRequiredSchema, stringLengthSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, date, object, string } from "yup";

const getValidationSchema = (currentTab, reportQuestions) => {
    switch (currentTab) {
        case 1:
            return object().shape({
                screening_date: date()
                    .nullable()
                    .required('Screening date is required'),
            });
        case 2:
            //   const locationQuestion = getQuestionById(INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.location, reportQuestions);
            //   const inputLabels = locationQuestion?.question_dd_labels || [];
            //   const labelsValidation = {};
            //   inputLabels?.length && inputLabels.forEach(label => {
            //     labelsValidation[label] = stringRequiredSchema;
            //   })

            return object({
                [ASSESSMENT_REPORT_V2_QUESTIONS.referral_reason]: object({
                    answer: stringLengthSchema(1500),
                }),
                [ASSESSMENT_REPORT_V2_QUESTIONS.background]: object({
                    answer: stringLengthSchema(1500),
                }),
                [ASSESSMENT_REPORT_V2_QUESTIONS.observation]: object({
                    answer: stringLengthSchema(1500),
                }),
            });
        case 3:
            return object().shape({
                assessment_plans: array().of(
                    object().shape({
                        summary: object().shape({
                            answer: string()
                                .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                                .required('This field is required'),
                        }),
                        diagnosis_severity: object().shape({
                            answer: string()
                                .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                                .required('This field is required'),
                        })
                    })
                ),
            });

        case 4:
            return object().shape({
                treatment_plans: array().of(
                    object().shape({
                        area_id: object().shape({
                            value: numberRequiredSchema,
                            label: stringRequiredSchema
                        }).required('This field is required'),
                        goal_id: object().shape({
                            value: numberRequiredSchema,
                            label: stringRequiredSchema
                        }).required('This field is required'),
                        AssessmentGoalStrategyData: array().of(object().shape({
                            answers: string()
                                .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                                .required('This field is required'),
                        })).min(1, "Atleast 1 strategy is required."),
                    })
                ),
            });
        case 5:
            return object({
                [ASSESSMENT_REPORT_V2_QUESTIONS.summary]: object({
                    answer: string()
                        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                        .required('This field is required'),
                }),
                [ASSESSMENT_REPORT_V2_QUESTIONS.clinical_impressions]: object({
                    answer: string()
                        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                        .required('This field is required'),
                }),
                recommendation: array().of(
                    object().shape({
                        answers: string()
                            .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                            .required('This field is required'),
                    })
                ),
            });
    }
}

export default getValidationSchema;